import React, { useEffect, useRef, useState } from 'react';

const AsDropdownContext = React.createContext();

const AsDropdownProvider = ({ children, ...props }) => {
    // Scrollbar gutter
    const gutterRef = useRef(null);
    // Area in which the scrollwheel can be used (just below the close button)
    const scrollableAreaRef = useRef(null);

    // Gap between top of body and top of scrollbar gutter
    const [gutterOffset, setGutterOffset] = useState(0);
    // Height of the entire component
    const [height, setHeight] = useState(0);
    // Visible height (excluding overflow)
    const [maxVisibleHeight, setMaxVisibleHeight] = useState(height);
    /* How many pixels to scroll the content. Please note that this is
     * not the same as the number of pixels the scrollbar has moved.
     * The scrollbar's position is calculated from this number using the 'offsetRatio'
     * found here: https://github.com/adserve/adserve-react-components/blob/master/src/scrollbar/ScrollbarSvg.jsx */
    const [scrollPx, setScrollPx] = useState(0);

    // Total height including overflow
    const [scrollableHeight, setScrollableHeight] = useState(100);

    // Is tongue visible? Starts expanded, then is swiftly retracted
    const [isExpanded, setIsExpanded] = useState(true);

    useEffect(() => {
        if (!scrollableAreaRef?.current) return;

        if (scrollableAreaRef?.current?.scrollHeight !== scrollableHeight) {
            setScrollableHeight(scrollableAreaRef?.current?.scrollHeight || 0);
        }
        setGutterOffset(
            (scrollableAreaRef?.current?.offsetTop || 0) +
                (scrollableAreaRef?.current?.offsetParent?.offsetTop || 0)
        );
        setMaxVisibleHeight(scrollableHeight?.current?.clientHeight || height);
    }, [
        scrollableAreaRef?.current?.scrollHeight,
        scrollableAreaRef?.current?.clientHeight
    ]);

    return (
        <AsDropdownContext.Provider
            {...props}
            value={{
                gutterOffset,
                height,
                isExpanded,
                gutterRef,
                maxVisibleHeight,
                scrollableAreaRef,
                scrollableHeight,
                scrollPx,
                setHeight,
                setIsExpanded,
                setScrollPx
            }}
        >
            {children}
        </AsDropdownContext.Provider>
    );
};

export { AsDropdownProvider, AsDropdownContext };
